export function encodeTokenForUrl(token) {
  if (token === null || typeof token !== 'string' || !token.trim()) {
    console.debug('encodeTokenForUrl: Token is null, empty, or not a string, returning empty string');
    return '';
  }

  try {
    const utf8Bytes = new TextEncoder().encode(token.trim());
    const binaryString = String.fromCharCode(...utf8Bytes);
    const base64Encoded = btoa(binaryString);
    return removeBase64Padding(base64Encoded);
  } catch (error) {
    console.error('Failed to encode token:', error);
    return '';
  }
}

export function removeBase64Padding(base64) {
  return base64.replace(/=+$/, '');
}
